import { render, staticRenderFns } from "./applicationHolidayModalVue.vue?vue&type=template&id=20848bbe"
import script from "./applicationHolidayModalVue.vue?vue&type=script&lang=js"
export * from "./applicationHolidayModalVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports